import { SxProps } from '@mui/material'
import { INPUT_MAX_WIDTH } from 'components/Field/constants'

export const FieldAutocompleteSx = (sx: SxProps = {}, fluid: boolean) => ({
  ...sx,
  maxWidth: !fluid ? INPUT_MAX_WIDTH : undefined,
})
